import { WidgetData } from "@/model/data/dashboard/WidgetData";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../../ApiGenericResponse";

export class FetchDashboardWidgetDataResData extends ApiGenericResponse {
    widgetData: WidgetData = null;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            var widgetData = new WidgetData();
            widgetData.fillFromJson(response.data.Payload);
            this.widgetData = widgetData;
        }
    }
}
